<template>
  <div>
    <b-row>
      <b-col sm="4">
        <b-input type="text" placeholder="Type to search" v-model.trim="filter"></b-input>
      </b-col>
      <b-col sm="4">
        <b-form-select :plain="true" :options="promotionOptions" v-model="selectStatus" text-field="Name"
          value-field="Value">
          <template slot="first">
            <option :value="null">-- Please select an option --</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row><br />
    <b-row>
      <b-col sm="12" md="12">
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm"
          :items="getRecords" :fields="fields" :per-page="perPage" :current-page="currentPage" :filter="filter">
          <template v-slot:cell(sn)="data">
            {{ data.index + 1 + ((currentPage - 1) * perPage) }}
          </template>
          <template v-slot:cell(Turnover)="data">
            <span>Last Hour: {{ format(data.item.LastTurnover, '0,0.00') }}</span><br/>
            <span>
              Current Hour: {{ format(data.item.Turnover, '0,0.00') }}
              <b-badge v-if="data.item.TurnoverTrend > 0" variant="success">({{ format(data.item.TurnoverTrend, '0,0.00') }}%)</b-badge>
              <b-badge v-else variant="warning">({{ format(data.item.TurnoverTrend, '0,0.00') }}%)</b-badge>
            </span>
          </template>
          <template v-slot:cell(NetWin)="data">
            <span>Last Hour: {{ format(data.item.LastNetWin, '0,0.00') }}</span><br/>
            <span>
              Current Hour: {{ format(data.item.NetWin, '0,0.00') }}
              <b-badge v-if="data.item.IsHouseWinning" variant="success">({{ format(data.item.NetWinTrend, '0,0.00') }}%)</b-badge>
              <b-badge v-else variant="danger">({{ format(data.item.NetWinTrend, '0,0.00') }}%)</b-badge>
            </span>
          </template>
        </b-table>
        <nav>
          <b-pagination :total-rows="getRowCount(getRecords)" :per-page="perPage" v-model="currentPage" prev-text="Prev"
            next-text="Next" />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import numeral from 'numeral'

export default {
  name: 'turnover-detail-table',
  props: {
    details: {
      type: Array,
      default: []
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      fields: [
        { key: 'sn', label: 'SN', thStyle: { width: '50px' } },
        { key: 'Username', label: 'Username' },
        { key: 'Turnover', label: 'Turnover', sortable: true },
        { key: 'NetWin', label: 'NetWin', sortable: true }
      ],
      currentPage: 1,
      perPage: 30
    }
  },
  computed: {
    getRecords: function () {
      return this.details
    }
  },
  methods: {
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    getRowCount (items) {
      return items.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/report/risk/game/GameTrendReportDetailTable.vue